import React, { Component } from 'react';
import PropTypes from 'prop-types';
import CustomSpinner from 'modules/ui/mobile/CustomSpinner.component';
import { View, Row, Text, Image, CloseX, Pressable } from 'modules/styled';

export default class UrlPreviewComponent extends Component {
  static propTypes = {
    size: PropTypes.string,
    image: PropTypes.string,
    title: PropTypes.string,
    urlPreview: PropTypes.object,
    domain: PropTypes.string,
    noLink: PropTypes.bool,
    urlMenu: PropTypes.func,
    remove: PropTypes.bool,
  };

  render() {
    const { remove, noLink, urlPreview, image, domain, size, title, urlMenu } =
      this.props;
    const isSmall = size === 'small';
    const height = isSmall ? 8 : 11;
    const imageFlex = isSmall ? 0.35 : 0.4;
    const fontSize = isSmall ? 1.5 : 2;

    const img = image || (urlPreview && urlPreview.image);
    const body = title || (urlPreview && urlPreview.title);
    const domainUrl = domain || (urlPreview && urlPreview.domain);

    const imageEl = img && (
      <Image
        resizeMode={'cover'}
        source={img ? { uri: img } : require('public/img/missing.png')}
        style={{ flex: 1 }}
      />
    );

    const domainEl = domainUrl && (
      <Text numberOfLines={1} sx={{ fontSize: fontSize * 8, color: 'grey', pt: 1.001 }}>
        from: {domainUrl}
      </Text>
    );

    const maxLines = isSmall && domainEl ? 2 : 3;

    return urlPreview ? (
      <View sx={{ variant: 'borders.navBorder', borderWidth: 1 }}>
        <Pressable nativeAction={urlMenu} to={'#'} disabled={noLink}>
          <Row sx={{ height, alignItems: 'stretch' }}>
            <View sx={{ flex: imageFlex }}>{imageEl || null}</View>
            <View
              sx={{
                justifyContent: 'center',
                flex: 1,
                flexBasis: '0%',
                p: 4.0001,
                overflow: 'hidden',
              }}
              style={{ flex: 1 }}
            >
              <Text
                sx={{
                  overflow: 'hidden',
                  fontSize: fontSize * 8,
                  lineHeight: fontSize * 8 * 1.3,
                  color: 'grey',
                }}
                numberOfLines={maxLines}
              >
                {body}
              </Text>
              {domainEl}
            </View>
            {remove && (
              <CloseX
                sx={{
                  width: 2,
                  height: 2,
                  top: 4.01,
                  right: 4.01,
                  opacity: 0.5,
                }}
                resizeMode={'contain'}
                source={require('public/img/x.png')}
              />
            )}
          </Row>
        </Pressable>
      </View>
    ) : (
      <Pressable sx={{ height }} nativeAction={urlMenu} to={'#'}>
        <Row
          sx={{
            height,
            alignItems: 'stretch',
            flex: 1,
            variant: 'borders.navBorder',
            borderWidth: 1,
          }}
        >
          <CustomSpinner size={'small'} visible />
        </Row>
      </Pressable>
    );
  }
}
